import { useState, useEffect } from 'react';
import { getItem } from '@/shared/utils/storage';
import { useRiderBasicInfo } from './useRiderBasicInfo';
import { useRiderAccountInfo } from './useRiderAccountInfo';
import { useRiderDeductions } from './useRiderDeductions';
import { useRiderTypeManagement } from './useRiderTypeManagement';

export const useRiderInfoDetail = (riderId?: string) => {
    const {
        loading,
        error,
        riderInfo,
        suppId,
        initialAccountInfo,
        initialRiderTypeCode,
        fetchRiderDetail,
    } = useRiderBasicInfo(riderId);

    const {
        accountInfo,
        setAccountInfo,
        bankOptions,
        handleSaveAccount,
        handleAccountNumberChange,
        handleAccountHolderChange,
    } = useRiderAccountInfo(riderId, initialAccountInfo);

    const { deductions, fetchDeductions } = useRiderDeductions(riderId, suppId);

    const { riderTypes, riderTypeLoading, selectedRiderType, handleRiderTypeChange, handleSaveRiderType } =
        useRiderTypeManagement(riderId, initialRiderTypeCode);

    const [userType, setUserType] = useState('');
    useEffect(() => {
        setUserType(getItem<string>('USER_TYPE') || '');
    }, []);

    return {
        loading,
        error,
        riderInfo,
        suppId,
        accountInfo,
        setAccountInfo,
        deductions,
        bankOptions,
        riderTypes,
        riderTypeLoading,
        selectedRiderType,
        userType,
        fetchRiderDetail,
        fetchDeductions,
        handleSaveAccount,
        handleAccountNumberChange,
        handleAccountHolderChange,
        handleRiderTypeChange,
        handleSaveRiderType,
    };
};
